import {
  WebsiteFontSettingsInterface,
  WebsiteStylesInterface,
} from '../types/website-settings-types'

const pickTypography = (typography?: WebsiteFontSettingsInterface) =>
  typography?.fontFamily
    ? {
        fontFamily: typography.fontFamily,
        fontFileId: typography.fontFileId,
        fontWeight: typography.fontWeight as string,
        fontStyle: typography.fontStyle as string,
      }
    : null

export const pickWebsiteStylesAllTypography = (
  websiteStyles?: WebsiteStylesInterface,
) => {
  return [
    pickTypography(websiteStyles?.formFields?.typography),
    pickTypography(websiteStyles?.buttonsAndLinks?.primary?.typography),
    pickTypography(websiteStyles?.buttonsAndLinks?.secondary?.typography),
    pickTypography(websiteStyles?.typography?.heading),
    pickTypography(websiteStyles?.typography?.paragraph),
  ].filter(typography => typography !== null)
}
